import { REQUEST_ATTEMPT_DEFAULT as Ae } from "../common/constants.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
const h = {
  O: {
    Nu: "data",
    wi: "content_cards/sync",
    Le: "feature_flags/sync",
    Er: "template",
    K: "banners/sync",
  },
  Vu: (t) => (null == t ? void 0 : t.ft(s.gt.lE)),
  sm: (t) => (null == t ? void 0 : t.ft(s.gt.SE)),
  nm: (t, e) => {
    null == t || t.Bt(s.gt.lE, e);
  },
  rm: (t, e) => {
    null == t || t.Bt(s.gt.SE, e);
  },
  zu: (t, e) => {
    if (!t || !e) return -1;
    const s = h.Vu(t);
    if (null == s) return -1;
    const n = s[e];
    return null == n || isNaN(n) ? -1 : n;
  },
  ju: (t, e) => {
    let s = Ae;
    if (!t || !e) return s;
    const n = h.sm(t);
    return null == n ? s : ((s = n[e]), null == s || isNaN(s) ? Ae : s);
  },
  W: (t, e, s) => {
    if (!t || !e) return;
    let n = h.Vu(t);
    null == n && (n = {}), (n[e] = s), h.nm(t, n);
  },
  Mu: (t, e, s) => {
    if (!t || !e) return;
    let n = h.sm(t);
    null == n && (n = {}), (n[e] = s), h.rm(t, n);
  },
  vi: (t, e) => {
    t && e && h.Mu(t, e, Ae);
  },
  Uu: (t, e) => {
    if (!t || !e) return;
    const s = h.ju(t, e);
    h.Mu(t, e, s + 1);
  },
};
export default h;
